import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../../services/config.service';
import { Observable } from 'rxjs';

@Injectable()
export class NotesService {
    constructor(private http: HttpClient, private config: ConfigService) {}

    delete(noteId: string): Observable<any> {
        return this.http.delete(
            `${this.config.getConfiguration().API_BASE}/note/${noteId}`,
            {}
        );
    }
}
